import {
  getCertifications,
  GetCertificationsPayloadType,
  getCertificationUserTestQuestions,
  GetCertificationUserTestQuestionsPayloadType,
} from '@api';
import { SetState } from '@store/store.type';
import { StoreGlobalType } from '@store/store';
import { certificationsApiMapper, certificationUserTestQuestionsApiMapper } from '@mappers';
import { getApiError } from '@store/helper';

import { CertificationSliceType } from './certification.slice';

/****************************************************************
 * GET CERTIFICATION
 *****************************************************************/

type GetCertificationsActionStatusType =
  | 'getCertifications/loading'
  | 'getCertifications/succeeded'
  | 'getCertifications/failed';

export type GetCertificationsActionPayloadType = GetCertificationsPayloadType;

export const getCertificationsAction =
  (
    set: SetState<
      Partial<CertificationSliceType & StoreGlobalType>,
      GetCertificationsActionStatusType,
      GetCertificationsActionPayloadType
    >,
  ) =>
    async (payload: GetCertificationsActionPayloadType) => {
      try {
        set(
          (state) => {
            state.getCertificationsAction.status = 'LOADING';
            state.error = undefined;
            state.success = undefined;
          },
          false,
          { type: 'getCertifications/loading', payload },
        );

        const certificationsApi = await getCertifications(payload);
        const certifications = certificationsApi?.map(certificationsApiMapper);

        set(
          (state) => {
            state.getCertificationsAction.status = 'SUCCEEDED';
            state.certificationsFiltered = certifications;
          },
          false,
          { type: 'getCertifications/succeeded' },
        );
      } catch (e) {
        set(
          (state) => {
            state.getCertificationsAction.status = 'FAILED';
            state.certificationsFiltered = [];
            state.error = getApiError(e);
          },
          false,
          { type: 'getCertifications/failed' },
        );
      }
    };

/****************************************************************
 * GET QUESTIONS RESPONDENT
 *****************************************************************/

type GetQuestionsRespondentActionStatusType =
  | 'getQuestionsRespondent/loading'
  | 'getQuestionsRespondent/succeeded'
  | 'getQuestionsRespondent/failed';

export type GetQuestionsRespondentActionPayloadType = GetCertificationUserTestQuestionsPayloadType;

export const getQuestionsRespondentAction =
  (
    set: SetState<
      Partial<CertificationSliceType & StoreGlobalType>,
      GetQuestionsRespondentActionStatusType,
      GetQuestionsRespondentActionPayloadType
    >,
  ) =>
    async (payload: GetQuestionsRespondentActionPayloadType) => {
      try {
        set(
          (state) => {
            state.getQuestionsRespondentAction.status = 'LOADING';
            state.error = undefined;
            state.success = undefined;
          },
          false,
          { type: 'getQuestionsRespondent/loading', payload },
        );

        const certificationUserTestQuestionsApi = await getCertificationUserTestQuestions(payload);
        const certificationUserTestQuestions = certificationUserTestQuestionsApi?.map(
          certificationUserTestQuestionsApiMapper,
        );

        set(
          (state) => {
            state.getQuestionsRespondentAction.status = 'SUCCEEDED';
            state.questionsRespondentFiltered = certificationUserTestQuestions;
          },
          false,
          { type: 'getQuestionsRespondent/succeeded' },
        );
      } catch (e) {
        set(
          (state) => {
            state.getQuestionsRespondentAction.status = 'FAILED';
            state.questionsRespondentFiltered = [];
            state.error = getApiError(e);
          },
          false,
          { type: 'getQuestionsRespondent/failed' },
        );
      }
    };
